import React from "react";
import { Breadcrumbs, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  typoTitle,
  smallBold,
  typoBase,
  mediumTitle,
  largeTitle,
} from "../styles/typography";

const Root = styled("div")(({ theme }) => ({
  //   padding: theme.spacing(2),
  //   backgroundColor: '#f8f8f8',
  //   borderRadius: '8px',
  //   boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
}));

const BreadcrumbsContainer = styled(Breadcrumbs)(({ theme }) => ({
  //   marginBottom: theme.spacing(1),
}));


const Title = styled(Typography)(({ theme }) => ({
  ...largeTitle,
  color: "rgb(35, 35, 35)",
  fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
  fontSize: "16px",
  fontWeight: 600,
  height: "22.75px",
  lineHeight: "22.75px",
  marginTop: "-7px",
}));

const BreadcrumbNav = ({ title, breadcrumbs, showBreadcrumbs = false }) => {
  const { t } = useTranslation('navigation');
  const navigate = useNavigate();

  return (
    <Root>
    {showBreadcrumbs && (
      <BreadcrumbsContainer
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs.map((breadcrumb, index) => (
          <Typography
            key={index}
            color="textPrimary"
            sx={{
              color: "#2B80B6",
              textDecoration: "none",
              fontFamily: "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
              fontSize: "10px",
              fontWeight: 400,
              height: "15.75px",
              lineHeight: "15.75px",
              cursor: "pointer",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            onClick={() => navigate(breadcrumb.href)}
          >
            {breadcrumb.label}
          </Typography>
        ))}
        <Typography
          color="textPrimary"
          sx={{
            color: "rgb(71, 71, 71)",
            fontFamily:
              "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
            fontSize: "10px",
            fontWeight: 400,
            height: "15.75px",
            lineHeight: "15.75px",
          }}
        >
          {title}
        </Typography>
      </BreadcrumbsContainer>
    )}
      <Title sx={{
        marginTop: "2px", fontFamily:
          "Fira Sans, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif",
        fontSize: "18px",
        fontWeight: 600,
      }}>{title}</Title>
    </Root>
  );
};

export default BreadcrumbNav;
